<template>
  <div class="footer">
    <div class="container">
      <div class="footer_text">
        <p>聯合線上公司 製作權所有 <br v-if="!isWeb">© udn.com All Rights Reserved.</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      isWeb: false
    }
  },
  mounted() {
    if(window.innerWidth>768){
      this.isWeb = true
    }else {
      this.isWeb = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.footer {
  background: #f1f1f1;
  width: 100%;
  margin-top: 30px;
  color: #7b7a7a;
}
.footer_text {
  padding: 12px 0;
  p {
    margin: 0;
    font-size: 1.06rem;
  }
}
</style>
